import Vue from 'vue';
import Router from 'vue-router';

import store from './store';

import Home from '@/views/Home';
import CreateProfileCandidate from '@/views/CreateProfileCandidate';
import Dashboard from '@/views/Dashboard';
import Profile from '@/views/PublicCandidateProfile';
import ChatMain from '@/views/ChatMain';
import FrequentlyAskedQuestions from '@/views/FrequentlyAskedQuestions';
import AccountWelcome from '@/views/AccountWelcome';
import AccountNotActive from '@/views/AccountNotActive';
import AccountActivation from '@/views/AccountActivation';
import CreateNewPassword from '@/views/CreateNewPassword';
import LogIn from '@/views/LogIn';
import SignUpCandidateView from '@/views/SignUpCandidateView';
import SignUpCompanyView from '@/views/SignUpCompanyView';

Vue.use(Router);
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*', redirect: '/' // redirect to home on a bad URL
    },
    {
      path: '/',
      name: 'Sign Up',
      component: Home,
      meta: {
        requiresAuthentication: false,
        requiresCandidateProfile: false
      }
    },
    {
      path: '/sign-up/candidate',
      name: 'Sign Up Candidate',
      component: SignUpCandidateView,
      meta: {
        requiresAuthentication: false,
        requiresCandidateProfile: false
      }
    },
    {
      path: '/sign-up/company',
      name: 'Sign Up Company',
      component: SignUpCompanyView,
      meta: {
        requiresAuthentication: false,
        requiresCandidateProfile: false
      }
    },
    {
      path: '/log-in',
      name: 'LogInView',
      component: LogIn,
      meta: {
        requiresAuthentication: false,
        requiresCandidateProfile: false
      }
    },
    {
      path: '/reset-password/:id',
      name: 'Create New Password',
      component: CreateNewPassword,
      meta: {
        requiresCandidateProfile: false
      }
    },
    {
      path: '/candidate/create-profile',
      name: 'Create Profile',
      component: CreateProfileCandidate,
      meta: {
        requiresAuthentication: true,
        requiresAccountActivation: true,
        isCandidateRoute: true,
        requiresCandidateProfile: false
      }
    },
    {
      path: '/account/welcome',
      name: 'Account Welcome',
      component: AccountWelcome,
      meta: {
        requiresAuthentication: true,
        requiresCandidateProfile: false
      }
    },
    {
      path: '/account/not-active',
      name: 'Account Not Active',
      component: AccountNotActive,
      meta: {
        requiresAuthentication: true,
        requiresCandidateProfile: false
      }
    },
    {
      path: '/account/activate/:id',
      name: 'Activate Account',
      component: AccountActivation,
      meta: {
        requiresCandidateProfile: false
      }
    },
    {
      path: '/dashboard',
      name: 'My Dashboard',
      component: Dashboard,
      meta: {
        requiresAuthentication: true,
        requiresAccountActivation: true,
        requiresCandidateProfile: true
      }
    },
    {
      path: '/profile/:id',
      name: 'Profile',
      component: Profile,
      meta: {
        requiresAuthentication: true,
        requiresAccountActivation: true,
        isCompanyRoute: true,
        requiresCandidateProfile: false
      }
    },
    {
      path: '/chat',
      name: 'Chat Main',
      component: ChatMain,
      meta: {
        requiresAuthentication: true,
        requiresAccountActivation: true,
        requiresCandidateProfile: true
      }
    },
    {
      path: '/frequently-asked-questions',
      name: 'Frequently Asked Questions',
      component: FrequentlyAskedQuestions,
      meta: {
        requiresCandidateProfile: false
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (store.state.user) routerPathForAuthenticatedUsers(to, from, next);
  // If user has an auth token but no session, try to log them in.
  else if (store.state.authToken && !store.state.user) {
    store.dispatch('initApp')
      .then(response => {
        routerPathForAuthenticatedUsers(to, from, next);
      })
      .catch(error => {
        console.log(error);
        next('/');
      });
  } else if (!store.state.authToken) routerPathForUnauthenticatedUsers(to, from, next);
});

export default router;

// Redirect users based on their auth state and account activation state.
// @TODO needs some props passed to display a notification.
function routerPathForAuthenticatedUsers (to, from, next) {
  if (to.matched.some(record => record.path === '/account/activate/:id')) next();
  else if (
    to.matched.some(record => record.meta.requiresAccountActivation)
    && !store.getters.isUserAccountActive
    && to.path !== '/account/not-active'
  ) {
    next('/account/not-active');
  } else if (
    to.matched.some(record => record.meta.isCandidateRoute)
    && store.getters.loggedInUserType !== 'candidate'
  ) {
    next('/dashboard');
  } else if (
    to.matched.some(record => record.meta.isCompanyRoute)
    && store.getters.loggedInUserType !== 'company'
  ) {
    next('/dashboard');
  } else if (
    to.path === '/log-in'
    || to.path === '/'
    || to.path === '/sign-up'
    || to.path === '/sign-up/candidate'
    || to.path === 'sign-up/company'
  ) {
    next('/dashboard');
  } else if (
    store.getters.isUserAccountActive
    && store.getters.loggedInUserType === 'candidate'
    && !store.getters.isCandidateProfileCompleted
    && to.matched.some(record => record.meta.requiresCandidateProfile)
  ) {
    next('/candidate/create-profile');
  } else {
    next();
  }
};

function routerPathForUnauthenticatedUsers (to, from, next) {
  if (to.matched.some(record => record.meta.requiresAuthentication)) next('/');
  else next();
};
